// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__2nGBK","menuItem":"Menu_menuItem__GhFho","activeItem":"Menu_activeItem__3cRFf","placeholderShimmer":"Menu_placeholderShimmer__33ZF2"};